module.exports = __webpack_public_path__ + "img/linkedin.861fb5f1.svg";